<template>
  <div
    class="setting-popup"
    v-if="boxData.judgeBox"
    :style="{
      top: boxData.fix.y + 'px',
      left: boxData.fix.x + 'px',
      'z-index': boxData.Zindex,
    }"
    @click="stopDocument($event)"
    @mousedown="stopDocument($event)"
  >
    <div
      class="setting-popup__drag-area"
      v-on:mousedown="moveStart($event, true)"
      v-on:mousemove="moveArea($event)"
      v-on:mouseup="saveMoveState($event)"
      :style="{ cursor: 'move' }"
    >
      请选择录音方式
    </div>
    <div class="setting-popup__content">
      <div class="new-msg" ref="feature">
        声音功能全新升级，配音面板即将下线，请到右上角<b>“声音与字幕”</b>处进行配音、配乐添加和设置。
      </div>
      <popup-content ref="content"></popup-content>
    </div>
    <div class="setting-popup__close" @click="close">
      <i class="icon-popup-close"></i>
    </div>
    <div
      class="setting-popup__mask"
      v-show="isShowMask"
      @click="closeNextPopup('color')"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import popup from '../mixins/popup'
import popupContent from './mySoundRecord/soundRecordLite'
// const myPopup = {
//   ...popup,
//   watch: {}
// };
export default {
  components: {
    popupContent
  },
  mixins: [
    popup
  ],
  watch: {
    'boxDatas.secondData': function (val, oldval) { // 判断打开关闭
      let name = this.popupType;
      let num = Array.indexOf(this.boxDatas.secondData, name);
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) { // 打开的操作
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.data = this.dataMsg[name];
        this.boxData.fix.x = this.dataMsg[name].posx + 2;
        this.boxData.fix.y = this.dataMsg[name].posy + 2;
      }
    },
    'boxData.fix': {
      handler (val) {
        this.$bus.emit('soundRecord.popupMoved', val);
      },
      deep: true,
    },
    SelectScenes_Msg (val) {
      this.close();
    },
    'boxData.judgeBox' (val) {
      if (val) {
        this.$refs.content && this.$refs.content.getSmartVoiceInfo();
        this.$bus.emit('showNewSoundMsg', true);
      }
    }
  },
  data () {
    return {
      popupType: 'textToVoice'
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.new-msg {
  width: 403px;
  height: 54px;
  background: #fff2e8;
  padding: 12px 20px;
  line-height: 15px;
  color: #9d6740;
  font-size: 12px;
  margin: auto;
  text-align: left;
}
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  // width: 290px;
  width: 500px;
  // height: 562px;
  z-index: 35;
  border-radius: 6px 6px 3px 3px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/popups/mySoundRecord.vue